import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OeAppPersonService } from './oe-app-person.service';
import { OeAppService } from './oe-app.service';
import { BetaFeatureType } from './types/beta-feature-type';
import { BetaTesterDto } from './types/BetaTesterDto';

@Injectable({
  providedIn: 'root',
})
export class BetaTesterService {
  constructor(private http: HttpClient, private oeApp: OeAppService, private oeAppPersonService: OeAppPersonService) {}

  isBetaTester(feature: BetaFeatureType): Observable<BetaTesterDto> {
    return this.http
      .get<BetaTesterDto>(
        `${this.oeApp.oeProfileServiceHost}/beta-testers?contactId=${this.oeAppPersonService.contactId}&feature=${feature}`
      )
      .pipe(catchError(() => of(null)));
  }

  isBetaTesterStudent(feature: BetaFeatureType): Observable<boolean> {
    return this.isBetaTester(feature).pipe(map((response) => response.enabled));
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/beta-tester.service.ts